import Immutable from 'seamless-immutable';
import { DEFAULT_RIGHTS } from './utils/viewable';
import storage from './utils/storage';
import packageJson from '../../package.json';
import { SUBTITLES_OFF } from '../common/constants';

const { version: hipsterPlayerVersion } = packageJson;

export const DEFAULT_VOLUME_STR = '1';

export function defaultModel() {
  const defaultLanguage = navigator.language || navigator.userLanguage || 'en-US';
  const storedAudio = storage.getItem('audioTrack');

  const bitrate = storage.getItem('bitrate') || 'auto';

  const storedText = storage.getItem('textTrack');

  return Immutable.from({
    audioTracks: [],
    videoTracks: [],
    adsPlaying: false,
    assetId: null,
    bufferingType: 'initial',
    certificate: null,
    chromecast: {
      enabled: false,
      appId: '',
    },
    airplayEnabled: false,
    currentAdaptation: {
      videoBitrate: 0,
      audioBitrate: 0,
      bitrate: 0,
      audioCodec: '',
      videoCodec: '',
    },
    currentTime: 0,
    currentTimeFloat: 0,
    defaultAudio: defaultLanguage,
    defaultLang: defaultLanguage,
    defaultText: defaultLanguage,
    headers: null,
    heartbeat: null,
    playerError: null, // { code: number, errorMessage: { message: string, values?: object } }
    isAirPlayAvailable: false,
    isAirPlaying: false,
    isFullscreen: false,
    isLive: false,
    isPlaying: false,
    isSeeking: false,
    isBuffering: false,
    isPlayedToEnd: false,
    isChromeCastAvailable: false,
    isChromeCasting: false,
    chromecastPlayableId: null,
    license: null,
    drm: '',
    protocol: 'dash',
    offsetFromLive: 0,
    playbackStartTime: 0,
    playlist: '',
    preferredAudio: storedAudio || defaultLanguage,
    preferredBitrate: bitrate,
    preferredLanguage: storedAudio || defaultLanguage,
    preferredText: storedText || SUBTITLES_OFF,
    buffer: {
      start: 0,
      end: 0,
    },
    seekRange: {
      start: 0,
      end: 0,
      startAbsolute: 0,
      endAbsolute: 0,
    },
    selectedAudio: storedAudio || defaultLanguage,
    selectedBitrate: bitrate,
    selectedLanguage: storedAudio || defaultLanguage,
    selectedText: SUBTITLES_OFF,
    streamType: null,
    streamDuration: 0,
    textTracks: [],
    textTracksPosition: -1,
    viewableId: '',
    metadata: {
      banner: '',
      title: '',
    },
    volume: parseFloat(storage.getItem('videoVolume') || DEFAULT_VOLUME_STR, 10),
    activeVideoVolume: parseFloat(storage.getItem('activeVideoVolume') || DEFAULT_VOLUME_STR, 10),
    hipsterPlayerVersion: hipsterPlayerVersion || 'unknown',
    detectAdblockers: false,
    surroundSound: false,
    parentalControl: false,
    parentalControlCheckInterval: 60000,
    baseUri: '',
    accessToken: null,
    authorizationKey: null,
    entitlementToken: null,
    viewable: null,
    rights: DEFAULT_RIGHTS,
    isPlayingDaiAds: false,
    muxKey: null,
    userId: null,
    partner: null,
    nextVideo: false,
    defaultClosingCreditsOffset: null,
  });
}
